import { Product } from '@shopify/theme-product-form'

export default class ProductDataCache {
  /**
   * @type {Map<string, Product>}
   */
  cache = new Map()

  async get(handle) {
    const product = this.cache.get(handle)

    if (product) {
      return product
    }

    const response = await fetch(`/products/${handle}.js`)
    const productData = await response.json()

    this.cache.set(handle, productData)

    return productData
  }
}
